import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http, API } from "./api";

const ContentCtx = createContext({ content: null, reload: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const reload = useCallback(async () => {
    if (!API) return;
    try {
      const { data } = await http.get("/content");
      setContent(data && typeof data === "object" ? data : null);
    } catch {
      setContent(null);
    }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return <ContentCtx.Provider value={{ content, reload, setContent }}>{children}</ContentCtx.Provider>;
}

export const useContent = () => useContext(ContentCtx);

export const PHONE_DISPLAY = "406-696-3771";
export const PHONE_TEL = "+14066963771";
export const usePhone = () => {
  const { content } = useContent();
  return {
    display: content?.contact?.phone_display || PHONE_DISPLAY,
    tel: content?.contact?.phone_e164 || PHONE_TEL,
  };
};

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    const canon = document.querySelector('link[rel="canonical"]');
    if (canon) canon.setAttribute("href", `https://rivantalabs.net${window.location.pathname}`);
  }, [title, description]);
}
